/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import { useAuthStore, useLoadingStore, useModalStore } from "../stores/hooks";

import { BANK_NAMES, VEHICLE_TYPE_LABELS } from "../constants";

import UpdateVehicleInfoModal from "../modals/UpdateVehicleInfoModal";

const CONTRACTS = {
  CONSIGNMENT_AGREEMENT: "consignmentAgreement",
  CONSIGNMENT_AGREEMENT_DOCUMENT: "consignmentAgreementDocument",
  PERSONAL_INFORMATION_SECURITY_PLEDGE: "personalInformationSecurityPledge",
  PERSONAL_INFOMATION_CONSENT_FORM: "personalInformationConsentForm",
};

const ContractViewer = ({ type, onClose }) => {
  const handleClickSignature = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ contractType: type }),
      );
    }
  };

  return (
    <div className="p-10">
      <img src={`/images/contracts/${type}.png`} alt="" className="w-full" />
      <div className="grid gap-10 mt-10">
        <button
          type="button"
          className="bg-orange text-white w-full p-10"
          onClick={handleClickSignature}
        >
          서명하기
        </button>
        <button type="button" className="w-full p-10" onClick={onClose}>
          취소
        </button>
      </div>
    </div>
  );
};

const PrivateInfoComponent = ({ onClose, onUpdate }) => {
  const { ...actions } = useAuthStore();
  const { ...loadingActions } = useLoadingStore();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async ({
    personalNumber1,
    personalNumber2,
    bankName,
    accountNumber,
    accountHolder,
  }) => {
    try {
      const data = {
        personalNumber: `${personalNumber1}${personalNumber2}`,
        bankName,
        accountNumber,
        accountHolder,
      };

      loadingActions.startLoading();

      await actions.updatePrivateInfo(data);

      onUpdate();
    } catch (e) {
      window.alert(`개인정보 수정에 실패했습니다. ${e?.message}`);
    } finally {
      loadingActions.finishLoading();
    }
  };

  return (
    <div className="p-10">
      <div className="font-medium text-16 mb-20">
        * 등록된 주민등록번호로 소득신고됩니다. 정확하게 입력해주십시오.
        <br />* 운송비 정산을 위해 제공된 개인정보는 암호화하여 당사 시스템에
        안전하게 보관됩니다.
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-10">
          <div className="font-bold text-16 mb-10">주민등록번호</div>
          <div className="flex gap-10 items-center justify-between flex-row">
            <input
              type="text"
              className="p-10 bg-[#f6f6f6] min-w-0 flex-1"
              {...register("personalNumber1", {
                required: "주민등록번호를 입력해주세요.",
                minLength: {
                  value: 6,
                  message: "주민등록번호를 정확히 입력해주세요.",
                },
                maxLength: {
                  value: 6,
                  message: "주민등록번호를 정확히 입력해주세요.",
                },
              })}
            />
            <input
              type="text"
              className="p-10 bg-[#f6f6f6] min-w-0 flex-1"
              {...register("personalNumber2", {
                required: "주민등록번호를 입력해주세요.",
                minLength: {
                  value: 7,
                  message: "주민등록번호를 정확히 입력해주세요.",
                },
                maxLength: {
                  value: 7,
                  message: "주민등록번호를 정확히 입력해주세요.",
                },
              })}
            />
          </div>
          <div className="text-orange text-14 mt-2">
            {errors.personalNumber1
              ? errors.personalNumber1.message
              : errors.personalNumber2
                ? errors.personalNumber2.message
                : ""}
          </div>
        </div>
        <div className="mb-10">
          <div className="font-bold text-16 mb-10">은행</div>
          <div className="flex gap-10 items-center justify-between flex-row">
            <select
              className="p-10 bg-[#f6f6f6] min-w-0 flex-1"
              {...register("bankName", {
                required: "은행을 선택해주세요.",
              })}
            >
              <option value="">은행을 선택해주세요.</option>
              {BANK_NAMES.map((bankName) => (
                <option key={bankName} value={bankName}>
                  {bankName}
                </option>
              ))}
            </select>
          </div>
          <div className="text-orange text-14 mt-2">
            {errors.bankName ? errors.bankName.message : ""}
          </div>
        </div>
        <div className="mb-10">
          <div className="font-bold text-16 mb-10">계좌번호</div>
          <input
            type="text"
            className="p-10 bg-[#f6f6f6] w-full"
            {...register("accountNumber", {
              required: "계좌번호를 입력해주세요.",
              minLength: {
                value: 10,
                message: "계좌번호를 정확히 입력해주세요.",
              },
              maxLength: {
                value: 20,
                message: "계좌번호를 정확히 입력해주세요.",
              },
            })}
          />
          <div className="text-orange text-14 mt-2">
            {errors.accountNumber ? errors.accountNumber.message : ""}
          </div>
        </div>
        <div className="mb-10">
          <div className="font-bold text-16 mb-10">예금주</div>
          <input
            type="text"
            className="p-10 bg-[#f6f6f6] w-full"
            {...register("accountHolder", {
              required: "예금주를 입력해주세요.",
              maxLength: {
                value: 10,
                message: "예금주를 정확히 입력해주세요.",
              },
            })}
          />
          <div className="text-orange text-14 mt-2">
            {errors.accountHolder ? errors.accountHolder.message : ""}
          </div>
        </div>
        <div className="grid gap-10 mt-10">
          <button type="submit" className="bg-orange text-white w-full p-10">
            수정하기
          </button>
          <button type="button" className="w-full p-10" onClick={onClose}>
            취소
          </button>
        </div>
      </form>
    </div>
  );
};

const VehicleInfoComponent = ({ onClose, onUpdate }) => {
  const { user } = useAuthStore().state;
  const { openModal } = useModalStore();

  const handleUpdate = () => {
    if (!user.vehicles?.length) {
      if (
        window.confirm(
          "기본 차량 정보가 등록되었습니다. 추가 차량 정보를 등록하시겠습니까?",
        )
      ) {
        openModal(
          <UpdateVehicleInfoModal
            key="update-vehicle-info-modal"
            onUpdate={onUpdate}
          />,
        );
        return;
      }
    }

    onUpdate();
  };
  return (
    <div className="p-10">
      <div className="font-medium text-16 mb-20">
        * 배송차량 정보를 정확히 입력해주십시오.
        <br />* 동일계정으로 2개 차량으로 배송하는 경우 2개 차량 정보 모두
        입력해주십시오.
      </div>
      <div className="text-16 font-medium mb-10">
        {user.vehicle1 && (
          <div className="mb-10">
            <b>차량1</b> {VEHICLE_TYPE_LABELS[user.vehicle1.vehicleType]}/
            {user.vehicle1.vehicleNumber}/{user.vehicle1.modelName}
          </div>
        )}
        <VehicleButton onUpdate={handleUpdate} initVehicleInfo={user.vehicle1}>
          기본 차량 {user.vehicle1 ? "수정" : "등록"}
        </VehicleButton>
      </div>
      <div>
        {user.vehicle2 && (
          <div className="mb-10">
            <b>차량2</b> {VEHICLE_TYPE_LABELS[user.vehicle2.vehicleType]}/
            {user.vehicle2.vehicleNumber}/{user.vehicle2.modelName}
          </div>
        )}
        <VehicleButton
          onUpdate={handleUpdate}
          initVehicleInfo={user.vehicle2}
          disabled={!user.vehicle1}
        >
          추가 차량 {user.vehicle2 ? "수정" : "등록"}
        </VehicleButton>
      </div>
      <div className="grid gap-10 mt-10">
        <button type="button" className="w-full p-10" onClick={onClose}>
          목록으로
        </button>
      </div>
    </div>
  );
};

const VehicleButton = ({ onUpdate, initVehicleInfo, disabled, children }) => {
  const { openModal } = useModalStore();

  const handleClick = () => {
    if (disabled) {
      window.alert("기본 차량 정보를 등록해주세요.");
      return;
    }

    openModal(
      <UpdateVehicleInfoModal
        key="update-vehicle-info-modal"
        onUpdate={onUpdate}
        initVehicleInfo={initVehicleInfo}
      />,
    );
  };

  return (
    <button
      type="button"
      className={`${!initVehicleInfo ? "bg-orange text-white" : "bg-white border-1 border-gray-a text-gray-a"} w-full p-10 mb-10`}
      onClick={handleClick}
    >
      {children}
    </button>
  );
};

const Button = ({ text, type, active, force, onClick }) => {
  const handleClick = () => {
    if (force || !active) {
      onClick(type);
    }
  };

  return (
    <button
      type="button"
      className={`border-1 bg-white ${
        active ? "border-orange text-orange" : "border-gray-a  text-gray-a"
      } w-full p-10`}
      onClick={handleClick}
    >
      {text}({active ? "완료" : "미완료"})
    </button>
  );
};

function SettingContract() {
  const { user, userPrivateInfo } = useAuthStore().state;
  const { ...actions } = useAuthStore();

  const { ...loadingActions } = useLoadingStore();

  const [contractType, setContractType] = useState(null);
  const [pagePrivateInfo, setPagePrivateInfo] = useState(false);

  const [pageVehicleInfo, setPageVehicleInfo] = useState(false);

  useEffect(() => {
    fetchMe();
    fetchPrivateInfo();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      document.addEventListener("message", receiveMessage);
    }, 200);

    return () => {
      document.removeEventListener("message", receiveMessage);
    };
  }, [user]);

  const receiveMessage = (e) => {
    if (e.data) {
      const message = JSON.parse(e.data);

      if (!!message.contractType && !!message.fileUrl) {
        updateContractSignature(message);
      }
    }
  };

  const fetchMe = async () => {
    try {
      loadingActions.startLoading();

      const response = await actions.fetchMe();

      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            vehiclesResult: response?.vehicles || [],
          }),
        );
      }
    } catch (e) {
      window.alert(`라이더 정보 조회에 실패했습니다. ${e?.message}`);
    }

    loadingActions.finishLoading();
  };

  const fetchPrivateInfo = async () => {
    try {
      loadingActions.startLoading();

      const response = await actions.fetchPrivateInfo();

      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            privateInfoResult: response,
          }),
        );
      }
    } catch (e) {
      window.alert(`라이더 개인정보 조회에 실패했습니다. ${e?.message}`);
    }
  };

  const handleClickContract = (type) => {
    setContractType(type);
  };

  const handleClickEnrollPrivacyCourse = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          enrollPrivacyCourse:
            "https://edu.privacy.go.kr/user/course/partyLogin.do",
        }),
      );

      updateEnrollPrivacyCours();
    }
  };

  const handleClickVehicleInfo = () => {
    setPageVehicleInfo(true);
  };

  const handleClickPrivateInfo = () => {
    setPagePrivateInfo(true);
  };

  const handleClose = () => {
    setContractType(null);
    setPagePrivateInfo(false);
    setPageVehicleInfo(false);
  };

  const handleUpdatePrivateInfo = () => {
    setPagePrivateInfo(false);
    fetchPrivateInfo();
  };

  const handleUpdateVehicleInfo = () => {
    setPageVehicleInfo(false);
    fetchMe();
  };

  const updateContractSignature = async (data) => {
    try {
      const _data = {
        [data.contractType]: data.fileUrl,
      };

      await actions.updateContractSignature(_data);

      window.alert(`서명을 저장했습니다.`);

      setContractType(null);

      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            contractResult: {
              consignmentAgreement: user?.consignmentAgreement,
              consignmentAgreementDocument: user?.consignmentAgreementDocument,
              personalInformationSecurityPledge:
                user?.personalInformationSecurityPledge,
              personalInformationConsentForm:
                user?.personalInformationConsentForm,
              enrolledPrivacyCourseAt: user?.enrolledPrivacyCourseAt,
              [data.contractType]: data.fileUrl,
            },
          }),
        );
      }

      fetchMe();
    } catch (e) {
      window.alert(`서명 저장에 실패했습니다. ${e?.message}`);
    }
  };

  const updateEnrollPrivacyCours = async () => {
    try {
      await actions.updateEnrollPrivacyCours();

      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            contractResult: {
              consignmentAgreement: user?.consignmentAgreement,
              consignmentAgreementDocument: user?.consignmentAgreementDocument,
              personalInformationSecurityPledge:
                user?.personalInformationSecurityPledge,
              personalInformationConsentForm:
                user?.personalInformationConsentForm,
              enrolledPrivacyCourseAt: new Date(),
            },
          }),
        );
      }

      fetchMe();
    } catch (e) {
      window.alert(`개인정보보호교육 수강 저장에 실패했습니다. ${e?.message}`);
    }
  };

  if (contractType) {
    return <ContractViewer type={contractType} onClose={handleClose} />;
  }

  if (pagePrivateInfo) {
    return (
      <PrivateInfoComponent
        onClose={handleClose}
        onUpdate={handleUpdatePrivateInfo}
      />
    );
  }

  if (pageVehicleInfo) {
    return (
      <VehicleInfoComponent
        onClose={handleClose}
        onUpdate={handleUpdateVehicleInfo}
      />
    );
  }

  return (
    <div className="flex justify-center items-center flex-col gap-10 min-h-screen p-10">
      <Button
        text="위탁계약서 서명"
        type={CONTRACTS.CONSIGNMENT_AGREEMENT_DOCUMENT}
        active={!!user.consignmentAgreementDocument}
        onClick={handleClickContract}
      />
      <Button
        text="위탁수수료지급 계약서 서명"
        type={CONTRACTS.CONSIGNMENT_AGREEMENT}
        active={!!user.consignmentAgreement}
        onClick={handleClickContract}
      />
      <Button
        text="개인정보보안서약서 서명"
        type={CONTRACTS.PERSONAL_INFORMATION_SECURITY_PLEDGE}
        active={!!user.personalInformationSecurityPledge}
        onClick={handleClickContract}
      />
      <Button
        text="개인정보제공 동의서 서명"
        type={CONTRACTS.PERSONAL_INFOMATION_CONSENT_FORM}
        active={!!user.personalInformationConsentForm}
        onClick={handleClickContract}
      />
      <Button
        text="개인정보보호교육 수강"
        active={!!user.enrolledPrivacyCourseAt}
        force={true}
        onClick={handleClickEnrollPrivacyCourse}
      />
      <Button
        text="운송비 정산을 위한 정보제공"
        active={!!userPrivateInfo.accountNumber}
        onClick={handleClickPrivateInfo}
      />
      <Button
        text="배송 차량 정보 제공"
        active={!!user.vehicles?.length}
        force={true}
        onClick={handleClickVehicleInfo}
      />

      {userPrivateInfo.accountNumber && (
        <div className="w-full text-14 mt-10">
          {userPrivateInfo.personalNumber.substring(0, 6)}-
          {userPrivateInfo.personalNumber.substring(6, 7)}******
          <br />
          {userPrivateInfo.bankName} {userPrivateInfo.accountNumber}
          <br />
          예금주: {userPrivateInfo.accountHolder}
          <br />* 수정이 필요한 경우 지역센터 관리자에게 문의해주십시오.
        </div>
      )}

      <div className="w-full text-14 mt-10">
        {user.vehicles?.length > 0 &&
          user.vehicles.map((vehicle, index) => (
            <div key={vehicle.id}>
              차량{index + 1} {VEHICLE_TYPE_LABELS[vehicle.vehicleType]}/
              {vehicle.vehicleNumber}/{vehicle.modelName}
            </div>
          ))}
      </div>
    </div>
  );
}

export default SettingContract;
